import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../components/Modal';
import ActionButton from '../../components/ActionButton';

import './_confirmActionPopup.scss';

const actions = {
  delete: {
    title: 'Are you sure you want to delete',
    subtitle: 'This action cannot be reversed',
    button: 'Delete'
  },
  launch: {
    title: 'Are you sure you want to launch',
    subtitle: 'This action cannot be reversed',
    button: 'Launch'
  },
  archive: {
    title: 'Are you sure you want to end',
    subtitle: 'This action cannot be undone. Are you sure you want to continue?',
    button: 'End bonus'
  },
  remove: {
    title: 'Are you sure you want to remove',
    subtitle: 'This action cannot be undone. Are you sure you want to continue?',
    button: 'Remove'
  },
  duplicate: {
    title: 'Are you sure you want to duplicate',
    subtitle: 'This action cannot be undone. Are you sure you want to continue?',
    button: 'Duplicate'
  },
  activate: {
    title: 'Are you sure you want to activate',
    subtitle: 'This action cannot be undone. Are you sure you want to continue?',
    button: 'Activate'
  },
  deactivate: {
    title: 'Are you sure you want to deactivate',
    subtitle: 'This action cannot be undone. Are you sure you want to continue?',
    button: 'Deactivate'
  },
  end: {
    title: 'Are you sure you want to end',
    subtitle: 'This action can not be reverse.',
    button: 'End Now'
  },
  cancelOrder: {
    title: 'Are you sure you want to cancel',
    subtitle: 'The commission for this order will be reversed. This action cannot be undone.',
    button: 'Cancel order'
  },
  discard: {
    title: 'Are you sure you want to discard',
    subtitle: 'Your unsaved changes will be lost.',
    button: 'Discard'
  },
  default: {
    title: '',
    subtitle: '',
    button: ''
  }
};

const ConfirmActionPopup = ({ type = 'default', multiple = false, open, confirmAction, cancelAction, objectName, object, loading = false }) => {

  return (
    <Modal open={open} closeModal={cancelAction} className="confirmActionPopup-popup">
      <div className="confirmActionPopup-header">
        <p className="confirmActionPopup-title">{actions[type].title} {multiple ? 'those' : 'this'} {objectName}?</p>
        <p className="confirmActionPopup-subtitle">
          {actions[type].subtitle}
        </p>
      </div>
      <div className="confirmActionPopup-buttons">
        <ActionButton variant="outlined" title="Cancel" onClick={cancelAction} />
        {confirmAction && <ActionButton className={type} title={actions[type].button} loading={loading} onClick={() => confirmAction(object)} />}
      </div>
    </Modal>
  );
};

ConfirmActionPopup.propTypes = {
  type: PropTypes.oneOf([
    'default', 'publish', 'archive',
    'delete', 'launch', 'remove',
    'duplicate', 'activate', 'deactivate',
    'end', 'cancelOrder', 'discard'
  ]),
  multiple: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  confirmAction: PropTypes.func,
  cancelAction: PropTypes.func.isRequired,
  object: PropTypes.any,
  objectName: PropTypes.oneOf(['user', 'creator', 'group', 'member', 'campaign', 'promotion', 'template', 'code', 'codes', 'gift', 'gifts', 'order', 'note', 'changes']).isRequired,
  loading: PropTypes.bool
};

export default ConfirmActionPopup;
